@if (loading) {
  <div class="container">
    <div class="body-container body-container--min-height">
      <app-loading-component></app-loading-component>
    </div>
  </div>
}